(() => {
  const isMobile = () => window.matchMedia('(max-width: 781px)').matches;
  const bindNavLinkLine = (host, lineHost, gsap, durationIn, durationOut) => {
    if (host.dataset.navLineBound) return;
    host.dataset.navLineBound = 'true';

    const line = document.createElement('span');
    line.className = 'babaa-nav-link__line';
    line.setAttribute('aria-hidden', 'true');
    lineHost.appendChild(line);

    gsap.set(line, { scaleX: 0, transformOrigin: 'left center' });

    const show = () => {
      gsap.to(line, { scaleX: 1, duration: durationIn, ease: 'power2.out', overwrite: 'auto' });
    };
    const hide = () => {
      gsap.to(line, { scaleX: 0, duration: durationOut, ease: 'power2.in', overwrite: 'auto' });
    };

    host.addEventListener('mouseenter', show);
    host.addEventListener('mouseleave', hide);
    host.addEventListener('focusin', show);
    host.addEventListener('focusout', event => {
      if (!host.contains(event.relatedTarget)) hide();
    });
  };

  const bindNavLinkLines = () => {
    const { gsap } = window;
    if (!gsap) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const durationIn = reducedMotion ? 0 : 0.35;
    const durationOut = reducedMotion ? 0 : 0.28;

    document
      .querySelectorAll(
        '.babaa-nav-item--has-menu:not(.babaa-nav-item--shop):not(.babaa-nav-item--about):not(.babaa-nav-item--support)'
      )
      .forEach(item => {
        const label = item.querySelector('.babaa-nav-item__label');
        if (!label) return;
        bindNavLinkLine(item, label, gsap, durationIn, durationOut);
      });

    document.querySelectorAll('.babaa-nav-item:not(.babaa-nav-item--has-menu) .babaa-nav-item__link').forEach(anchor => {
      const label = anchor.querySelector('.babaa-nav-item__label');
      if (!label) return;
      bindNavLinkLine(anchor, label, gsap, durationIn, durationOut);
    });

    document.querySelectorAll('.babaa-dropdown__heading[href], .babaa-dropdown__links a').forEach(link => {
      bindNavLinkLine(link, link, gsap, durationIn, durationOut);
    });
  };

  const bindHeaderSearch = () => {
    document.querySelectorAll('.babaa-header-search:not([data-babaa-predictive-form])').forEach(form => {
      if (form.dataset.searchBound) return;
      form.dataset.searchBound = 'true';

      form.addEventListener('submit', event => {
        const input = form.querySelector('[name="q"]');
        const query = input?.value?.trim();
        if (!query) {
          event.preventDefault();
          input?.focus();
        }
      });
    });
  };

  const bindScrollHeader = () => {
    if (document.body.classList.contains('babaa-shop-home')) return;

    const shell = document.querySelector('.babaa-header-shell');
    if (!shell || shell.dataset.scrollBound) return;
    shell.dataset.scrollBound = 'true';

    const update = () => {
      shell.classList.toggle('is-fixed', window.scrollY > 0);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
  };

  const syncMobileNavScroll = (navigation, navItem) => {
    if (!isMobile() || !navigation) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const maxScroll = Math.max(0, navigation.scrollHeight - navigation.clientHeight);
        if (navItem) {
          navigation.scrollTop = Math.min(Math.max(navItem.offsetTop, 0), maxScroll);
        } else {
          navigation.scrollTop = Math.min(navigation.scrollTop, maxScroll);
        }
      });
    });
  };

  const bind = () => {
    const button = document.querySelector('.babaa-mobile-toggle');
    const navigation = document.getElementById('babaa-navigation');
    if (!button || !navigation || button.dataset.bound) return;
    button.dataset.bound = 'true';

    const close = () => {
      navigation.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      navigation.querySelectorAll('.babaa-nav-item--has-menu.is-expanded').forEach(item => {
        item.classList.remove('is-expanded');
        const trigger = item.querySelector('.babaa-nav-item__trigger');
        trigger?.setAttribute('aria-expanded', 'false');
      });
    };

    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      navigation.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      if (!open) close();
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        close();
        button.focus();
      }
    });

    document.addEventListener('click', event => {
      if (!event.target.closest('.babaa-header')) close();
    });

    navigation.querySelectorAll('.babaa-nav-item--has-menu').forEach(item => {
      const trigger = item.querySelector('.babaa-nav-item__trigger');
      if (!trigger || trigger.dataset.subBound) return;
      trigger.dataset.subBound = 'true';

      trigger.addEventListener('click', event => {
        if (!isMobile()) return;
        event.preventDefault();
        const expanded = item.classList.toggle('is-expanded');
        trigger.setAttribute('aria-expanded', String(expanded));
        if (expanded) {
          navigation.querySelectorAll('.babaa-nav-item--has-menu.is-expanded').forEach(other => {
            if (other !== item) {
              other.classList.remove('is-expanded');
              other.querySelector('.babaa-nav-item__trigger')?.setAttribute('aria-expanded', 'false');
            }
          });
          syncMobileNavScroll(navigation, item);
        } else {
          syncMobileNavScroll(navigation);
        }
      });
    });
  };

  const init = () => {
    bindHeaderSearch();
    bindScrollHeader();
    bind();
    bindNavLinkLines();
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
